import { useUserQuery } from './useUserQuery';

export const useIsCountrySettingsAvailable = () => {
  const availableCountries = useUserQuery().data?.availableCountries ?? [];

  return availableCountries.length > 1;
};
